<template>
  <Modal
    :title="$t('edit_category')"
    modalId="edit-modal"
    @submit="updateCategory"
  >
    <form @submit.prevent="updateCategory">
      <div class="mb-3">
        <label class="form-label">{{ $t('category_name') }} <span class="">*</span></label>
        <input
          type="text"
          v-model="category.node"
          class="form-control"
        />
        <!-- Error for category node -->
        <div v-if="errors.node" class="text-danger mt-2">
          <span>{{ errors.node }}</span>
        </div>
      </div>
      <!-- General error message -->
      <div v-if="errorMessage" class="text-danger mt-2">{{ errorMessage }}</div>
    </form>
  </Modal>
</template>

<script>
import Modal from '@/components/common/Modal.vue';
import apiUrls from '../../../urls';
import {useToast} from "vue-toastification";

export default {
  components: {
    Modal,
  },

  props: {
    selectedCategory: {
      type: Object,
      default: () => ({}),
    },
  },

  setup() {
    const toast = useToast()
    return {toast}
  },

  data() {
    return {
      category: {
        id: null,
        node: '',
      },
      errorMessage: '',  // General error message (if any)
      errors: {},        // For storing individual field errors
    };
  },
  watch: {
    selectedCategory: {
      immediate: true,
      handler(newCategory) {
        if (newCategory && newCategory.id) {
          this.category = { ...newCategory }; // Copy selected category data
        }
      },
    },
  },
  methods: {
    async updateCategory() {
      try {
        const response = await this.$axios.patch(
          apiUrls.categories.update.replace(':pk', this.category.id),
          { node: this.category.node }
        );

        this.toast.success("Category successfully updated!");

        // Close modal after success
        const modal = document.getElementById('edit-modal');
        const modalInstance = bootstrap.Modal.getInstance(modal);
        if (modalInstance) modalInstance.hide();

        // Emit event to update parent component
        this.$emit('edit_success');

        this.resetForm();
      } catch (error) {
        if (error.response) {
          if (error.response.data) {
            // Check if 'node' field is in errors and assign full error message
            if (error.response.data.node && error.response.data.node.length > 0) {
              // Assign the full error message from the array
              this.errors.node = error.response.data.node[0];
            }

            // Handle general error message from backend
            if (error.response.data.error) {
              this.errorMessage = error.response.data.error;
            }
          }
        }
      }
    },

    resetForm() {
      this.category = { id: null, node: '' };
      this.errors = {};
      this.errorMessage = '';
    },
  },
};
</script>

